import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import { PolymorphicElement } from '../../utils/polymorphic-element';
import styles from './style.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedWrapper({
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    ref: ref,
    ...props,
    className: clsx(styles.wrapper, className)
  });
}
function UnforwardedStyledField({
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    ref: ref,
    ...props,
    className: clsx(styles.field, className)
  });
}
function UnforwardedStyledLabel({
  as,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    as: as ?? 'label',
    ref: ref,
    ...props,
    className: clsx(styles.label, className)
  });
}
function UnforwardedStyledHelp({
  as,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    as: as ?? 'p',
    ref: ref,
    ...props,
    className: clsx(styles.help, className)
  });
}
function UnforwardedStyledVisualLabel({
  as,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    as: as ?? 'span',
    ref: ref,
    ...props,
    className: clsx(styles.label, className)
  });
}
export const Wrapper = forwardRef(UnforwardedWrapper);
export const StyledField = forwardRef(UnforwardedStyledField);
export const StyledLabel = forwardRef(UnforwardedStyledLabel);
export const StyledHelp = forwardRef(UnforwardedStyledHelp);
export const StyledVisualLabel = forwardRef(UnforwardedStyledVisualLabel);